/**
 * Directive: paymentContactInfo
 */
angular.module('acme.common.directive.paymentContactInfo', [])
.directive('paymentContactInfo', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/paymentContactInfo/paymentContactInfo.tpl.html',
      scope: {
        contactName : '=',
        contactEmail : '=',
        contactPhoneNumber : '=',
        contactAddress: '='
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.paymentContactInfo = "Your spankin new paymentContactInfo!";

      }]

    };

}]);